import { render, staticRenderFns } from "./AbortedCampaignCard.vue?vue&type=template&id=c8f268cc&scoped=true&"
import script from "./AbortedCampaignCard.vue?vue&type=script&lang=ts&"
export * from "./AbortedCampaignCard.vue?vue&type=script&lang=ts&"
import style0 from "./AbortedCampaignCard.vue?vue&type=style&index=0&id=c8f268cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8f268cc",
  null
  
)

export default component.exports